var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo1713(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Aksarben_logo_rgb",
    xmlns: "http://www.w3.org/2000/svg",
    width: 257.639,
    height: 80,
    viewBox: "0 0 257.639 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aksarben_RGB"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M248.346,0H0V80H257.639V0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M10.9,65.92v3.95h4.284V65.92H16.34v9.442H15.188V70.939H10.9v4.424H9.76V65.92Z",
    transform: "translate(-0.689 -4.656)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M23.842,70.939H20.4v3.4h3.838v1.022H19.27V65.92h4.777v1.022H20.413v2.983h3.439v1.013Z",
    transform: "translate(-1.361 -4.656)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M27.88,72.388l-.92,2.974H25.78l3.011-9.442h1.375l3.02,9.442H31.97l-.948-2.974H27.88Zm2.9-.957-.864-2.714c-.2-.613-.325-1.18-.455-1.729h-.028c-.13.558-.279,1.134-.446,1.71l-.864,2.732h2.667Z",
    transform: "translate(-1.821 -4.656)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M35.945,66.951h-2.7V65.91H39.8v1.041H37.1v8.411H35.945V66.951Z",
    transform: "translate(-2.349 -4.655)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M42.793,65.92v9.442H41.65V65.92Z",
    transform: "translate(-2.942 -4.656)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M45.31,75.362V65.919h1.245L49.39,70.7a26.4,26.4,0,0,1,1.589,3.067l.028-.019c-.1-1.264-.13-2.407-.13-3.885V65.91h1.078v9.442H50.8L48,70.557a31.242,31.242,0,0,1-1.654-3.151l-.037.019c.065,1.19.093,2.323.093,3.894v4.033H45.319Z",
    transform: "translate(-3.2 -4.655)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M61.588,74.936a7.8,7.8,0,0,1-2.714.52,4.377,4.377,0,0,1-3.309-1.245,5.054,5.054,0,0,1-1.236-3.522,4.582,4.582,0,0,1,4.8-4.879,5.173,5.173,0,0,1,2.2.437l-.279.994a4.351,4.351,0,0,0-1.961-.409c-2.156,0-3.559,1.431-3.559,3.8s1.357,3.81,3.411,3.81a3.516,3.516,0,0,0,1.524-.251V71.377h-1.8V70.4h2.918v4.535Z",
    transform: "translate(-3.837 -4.648)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M68.376,73.486a1.4,1.4,0,0,1-1.366-1.459,1.378,1.378,0,1,1,1.375,1.45h-.009Z",
    transform: "translate(-4.733 -4.982)",
    fill: "#e12726"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M76.5,72.388l-.92,2.974H74.4l3.011-9.442h1.375l3.02,9.442H80.59l-.948-2.974H76.5Zm2.9-.957-.864-2.714c-.2-.613-.325-1.18-.455-1.729h-.028c-.13.558-.279,1.134-.446,1.71l-.864,2.732h2.667Z",
    transform: "translate(-5.255 -4.656)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M85.193,65.92v9.442H84.05V65.92Z",
    transform: "translate(-5.937 -4.656)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M87.72,66.035a10.857,10.857,0,0,1,2.193-.2,3.5,3.5,0,0,1,2.565.771,2.6,2.6,0,0,1-.967,4.2v.046a2.349,2.349,0,0,1,1.3,1.905,16.573,16.573,0,0,0,.678,2.593h-1.18a12.778,12.778,0,0,1-.595-2.258c-.26-1.3-.734-1.794-1.775-1.831H88.863v4.089H87.72V66.035Zm1.143,4.3h1.171a1.788,1.788,0,0,0,2-1.794c0-1.217-.827-1.747-2.035-1.766a4.514,4.514,0,0,0-1.134.112Z",
    transform: "translate(-6.196 -4.65)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M105.019,75.044a5.346,5.346,0,0,1-2.342.465c-2.491,0-4.377-1.691-4.377-4.8s1.877-4.963,4.619-4.963a4.481,4.481,0,0,1,2.1.418l-.279.994a3.966,3.966,0,0,0-1.784-.39c-2.072,0-3.457,1.413-3.457,3.894,0,2.314,1.245,3.8,3.4,3.8a4.445,4.445,0,0,0,1.868-.39l.232.967Z",
    transform: "translate(-6.943 -4.644)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M114.586,70.526c0,3.253-1.849,4.972-4.108,4.972s-3.978-1.933-3.978-4.8c0-3,1.747-4.963,4.108-4.963s3.978,1.98,3.978,4.777Zm-6.868.158c0,2.017,1.022,3.829,2.825,3.829s2.835-1.784,2.835-3.922c0-1.877-.92-3.838-2.825-3.838s-2.835,1.868-2.835,3.941Z",
    transform: "translate(-7.522 -4.643)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M117.08,75.362V65.919h1.245L121.16,70.7a26.4,26.4,0,0,1,1.589,3.067l.028-.019c-.1-1.264-.13-2.407-.13-3.885V65.91h1.078v9.442h-1.152l-2.807-4.8a31.24,31.24,0,0,1-1.654-3.151l-.037.019c.065,1.19.093,2.323.093,3.894v4.033h-1.078Z",
    transform: "translate(-8.27 -4.655)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M126.66,66.035a15.442,15.442,0,0,1,2.426-.2,4.871,4.871,0,0,1,3.587,1.18,4.5,4.5,0,0,1,1.245,3.392,4.6,4.6,0,0,1-5.186,5.028,18.3,18.3,0,0,1-2.072-.112V66.035ZM127.8,74.39a6.7,6.7,0,0,0,1.152.074c2.444,0,3.773-1.459,3.773-4.006.009-2.23-1.171-3.643-3.587-3.643a5.732,5.732,0,0,0-1.338.13V74.4Z",
    transform: "translate(-8.946 -4.65)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M137.5,65.92v9.442H136.36V65.92Z",
    transform: "translate(-9.631 -4.656)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M141.615,66.951h-2.7V65.91h6.552v1.041h-2.7v8.411h-1.152Z",
    transform: "translate(-9.812 -4.655)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M148.463,65.92v9.442H147.32V65.92Z",
    transform: "translate(-10.406 -4.656)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M158.505,70.526c0,3.253-1.849,4.972-4.108,4.972s-3.978-1.933-3.978-4.8c0-3,1.747-4.963,4.108-4.963s3.978,1.98,3.978,4.777Zm-6.868.158c0,2.017,1.022,3.829,2.825,3.829s2.835-1.784,2.835-3.922c0-1.877-.92-3.838-2.825-3.838s-2.835,1.868-2.835,3.941Z",
    transform: "translate(-10.624 -4.643)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M161,75.362V65.919h1.245L165.08,70.7a26.406,26.406,0,0,1,1.589,3.067l.028-.019c-.1-1.264-.13-2.407-.13-3.885V65.91h1.078v9.442h-1.152l-2.807-4.8a31.243,31.243,0,0,1-1.654-3.151l-.037.019c.065,1.19.093,2.323.093,3.894v4.033h-1.078Z",
    transform: "translate(-11.372 -4.655)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M171.723,65.92v9.442H170.58V65.92Z",
    transform: "translate(-12.048 -4.656)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M174.24,75.362V65.919h1.245L178.32,70.7a26.406,26.406,0,0,1,1.589,3.067l.028-.019c-.1-1.264-.13-2.407-.13-3.885V65.91h1.078v9.442h-1.152l-2.807-4.8a31.24,31.24,0,0,1-1.654-3.151l-.037.019c.065,1.19.093,2.323.093,3.894v4.033h-1.078Z",
    transform: "translate(-12.307 -4.655)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M190.518,74.936a7.811,7.811,0,0,1-2.723.52,4.377,4.377,0,0,1-3.309-1.245,5.054,5.054,0,0,1-1.236-3.522,4.582,4.582,0,0,1,4.8-4.879,5.173,5.173,0,0,1,2.2.437l-.279.994a4.337,4.337,0,0,0-1.952-.409c-2.156,0-3.559,1.431-3.559,3.8s1.357,3.81,3.411,3.81a3.516,3.516,0,0,0,1.524-.251V71.377h-1.8V70.4h2.918v4.535Z",
    transform: "translate(-12.943 -4.648)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M197.316,73.486a1.409,1.409,0,0,1-1.366-1.459,1.378,1.378,0,1,1,1.375,1.45h-.009Z",
    transform: "translate(-13.84 -4.982)",
    fill: "#e12726"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M204.06,66.026a11.961,11.961,0,0,1,2.193-.186,3.437,3.437,0,0,1,2.481.79,2.627,2.627,0,0,1,.771,1.98,2.907,2.907,0,0,1-.678,2.017,3.535,3.535,0,0,1-2.7,1.041,3.93,3.93,0,0,1-.92-.084v3.783H204.06V66.035ZM205.2,70.58a3.434,3.434,0,0,0,.948.1,1.942,1.942,0,0,0,2.221-2.017c0-1.3-.827-1.849-2.091-1.849a4.011,4.011,0,0,0-1.078.1v3.671Z",
    transform: "translate(-14.413 -4.65)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M211.86,65.92H213v8.42h3.783v1.022H211.86Z",
    transform: "translate(-14.964 -4.656)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M219.442,65.92v5.595c0,2.119.883,3.011,2.063,3.011,1.31,0,2.156-.929,2.156-3.011V65.92h1.152v5.511c0,2.9-1.431,4.089-3.346,4.089-1.812,0-3.178-1.106-3.178-4.033V65.92h1.152Z",
    transform: "translate(-15.418 -4.656)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M235.177,71.217c-.065-1.32-.149-2.9-.13-4.08h-.037c-.3,1.106-.669,2.3-1.115,3.587l-1.561,4.582h-.864l-1.431-4.5c-.418-1.329-.771-2.546-1.022-3.671h-.028c-.028,1.18-.093,2.76-.167,4.173l-.232,4.052H227.5l.613-9.442h1.459l1.506,4.572c.372,1.162.669,2.2.892,3.178h.037c.223-.957.539-1.989.929-3.178l1.58-4.572h1.459l.548,9.442h-1.115l-.223-4.145Z",
    transform: "translate(-16.069 -4.656)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M239.369,66.035a10.518,10.518,0,0,1,2.091-.2,3.488,3.488,0,0,1,2.426.688,2.031,2.031,0,0,1,.734,1.664,2.227,2.227,0,0,1-1.5,2.072v.028a2.394,2.394,0,0,1,1.822,2.37,2.617,2.617,0,0,1-.753,1.9,4.236,4.236,0,0,1-3.058.883,12.609,12.609,0,0,1-1.775-.112V66.035Zm1.143,3.866h1.041c1.208,0,1.915-.669,1.915-1.58,0-1.106-.79-1.543-1.942-1.543a4.343,4.343,0,0,0-1.013.084V69.9Zm0,4.526a6.274,6.274,0,0,0,.957.056c1.18,0,2.268-.465,2.268-1.84,0-1.292-1.041-1.822-2.286-1.822H240.5v3.6Z",
    transform: "translate(-16.906 -4.65)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M248.463,65.92v9.442H247.32V65.92Z",
    transform: "translate(-17.469 -4.656)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M250.98,75.362V65.919h1.245L255.06,70.7a26.4,26.4,0,0,1,1.589,3.067l.028-.019c-.1-1.264-.13-2.407-.13-3.885V65.91h1.078v9.442h-1.152l-2.807-4.8a31.24,31.24,0,0,1-1.654-3.151l-.037.019c.065,1.19.093,2.323.093,3.894v4.033h-1.078Z",
    transform: "translate(-17.727 -4.655)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M267.258,74.936a7.8,7.8,0,0,1-2.714.52,4.377,4.377,0,0,1-3.309-1.245A5.054,5.054,0,0,1,260,70.689a4.582,4.582,0,0,1,4.8-4.879,5.173,5.173,0,0,1,2.2.437l-.279.994a4.337,4.337,0,0,0-1.952-.409c-2.156,0-3.559,1.431-3.559,3.8s1.357,3.81,3.411,3.81a3.516,3.516,0,0,0,1.524-.251V71.377h-1.8V70.4h2.918v4.535Z",
    transform: "translate(-18.364 -4.648)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M34.771,35.2l-.465-1.924c-2.732,1.887-5.511,2.444-9.136,2.444-4.591,0-8.671-1.682-8.671-5.428,0-8.169,17.3-4.461,17.3-7.835,0-1.31-2.128-1.478-3.151-1.478-1.348,0-3.151.2-3.383,1.747H17.987c0-3.81,3.662-6.041,13.262-6.041,11.5,0,12.193,3.16,12.193,7.454v8.411a2.118,2.118,0,0,0,1.3,2.3V35.2H34.771ZM33.8,27.238c-3.151,1.134-7.323.586-7.323,2.918,0,.892,1.162,1.515,3.058,1.515,3.383,0,4.5-1.961,4.266-4.424Z",
    transform: "translate(-1.165 -1.179)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M59.817,29.675v5.046H50.17V10h9.647V22.221l6.171-5.493H77.252l-9,6.97L78.414,34.721H66.824l-5.2-6.385-1.8,1.338Z",
    transform: "translate(-3.544 -0.706)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M90.631,29.6a1.83,1.83,0,0,0,1.022,1.645,4.869,4.869,0,0,0,2.361.548c1.487,0,3.058-.344,3.058-1.617,0-2.881-14.879-.586-14.879-7.556,0-4.6,6.441-5.939,11.5-5.939,5.288,0,11.5.892,12.054,5.669H96.979a1.79,1.79,0,0,0-.929-1.3A3.862,3.862,0,0,0,94.1,20.6c-1.673,0-2.732.381-2.732,1.273,0,2.509,15.344.818,15.344,7.556,0,3.745-4.173,6.283-13.076,6.283-5.567,0-11.682-1.273-12.193-6.115h9.182Z",
    transform: "translate(-5.752 -1.178)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M129.8,35.2l-.465-1.924c-2.732,1.887-5.52,2.435-9.136,2.435-4.591,0-8.671-1.682-8.671-5.428,0-8.169,17.3-4.461,17.3-7.825,0-1.3-2.128-1.478-3.151-1.478-1.348,0-3.151.2-3.383,1.747h-9.275c0-3.81,3.662-6.041,13.262-6.041,11.5,0,12.193,3.16,12.193,7.454v8.411a2.118,2.118,0,0,0,1.3,2.3V35.2h-9.963Zm-.976-7.965c-3.151,1.134-7.323.586-7.323,2.918,0,.892,1.162,1.515,3.058,1.515C127.943,31.671,129.058,29.71,128.826,27.238Z",
    transform: "translate(-7.878 -1.179)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    d: "M144.16,17.2h8.764v3.643h.093c1.348-2.816,3.708-4.154,7.463-4.154.418,0,.836.074,1.255.1V23.93c-.651-.065-1.348-.2-1.989-.2-3.941,0-5.939,1.375-5.929,5.251v6.217h-9.647V17.2Z",
    transform: "translate(-10.182 -1.179)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    d: "M175.757,18.55a10.039,10.039,0,0,1,7-2.333c6.208,0,10.567,3.987,10.567,9.414s-3.058,9.619-10.985,9.619c-4.033,0-6.255-1.338-7.463-3.058h-.093V34.73H166.11V10h9.647Zm7.928,7.314a4.081,4.081,0,0,0-8.16-.13c0,1.924.929,4.359,4.08,4.359S183.684,27.825,183.684,25.864Z",
    transform: "translate(-11.733 -0.706)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M208.177,27.815c0,2.128,2.221,3.541,4.777,3.541a4.169,4.169,0,0,0,3.615-1.58H225.8c-1.664,4.461-7.788,5.939-13.448,5.939-7.788,0-13.81-3.3-13.82-9.34,0-5.911,5.976-9.684,13.764-9.684,9,0,14.424,4.6,14.284,11.125h-18.4Zm8.764-3.643c0-1.645-2-3.123-4.266-3.123-2.872,0-4.5,1.2-4.5,3.123Z",
    transform: "translate(-14.023 -1.179)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M231.92,17.2h8.81v2.816a10.648,10.648,0,0,1,8.206-3.327c6.4,0,9.415,2.779,9.415,7.723V35.194H248.7V25.686c0-1.784-.651-3.364-3.383-3.364-2.965,0-3.755,1.4-3.755,3.708V35.2h-9.638V17.21Z",
    transform: "translate(-16.381 -1.179)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M266.116,16.5a3.86,3.86,0,1,1-.019,0Zm-.046.753a2.849,2.849,0,1,0,.009,0h-.019Zm-.725,5.214-.892-.019.074-4.2a7.719,7.719,0,0,1,1.348-.093,2.3,2.3,0,0,1,1.44.362,1.054,1.054,0,0,1,.353.911.993.993,0,0,1-.818.957v.037c.362.074.595.418.651,1.041a3.546,3.546,0,0,0,.214,1.05l-.92-.019a3.365,3.365,0,0,1-.232-1.1.687.687,0,0,0-.781-.651h-.4l-.028,1.729Zm.037-2.416h.418c.52.019.929-.149.939-.586,0-.353-.242-.623-.846-.641h-.483l-.019,1.208Z",
    transform: "translate(-18.523 -1.165)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1739",
    "data-name": "Rectangle 1739",
    width: 239.089,
    height: 5.855,
    transform: "translate(9.229 37.695)",
    fill: "#0c223f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1740",
    "data-name": "Rectangle 1740",
    width: 239.089,
    height: 5.855,
    transform: "translate(9.257 44.963)",
    fill: "#0063a7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1741",
    "data-name": "Rectangle 1741",
    width: 239.052,
    height: 5.855,
    transform: "translate(9.294 52.323)",
    fill: "#9acae9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1713);
export default __webpack_public_path__ + "static/media/logo_1713.d8eada56eb5e572550fdc5c99191548b.svg";
export { ForwardRef as ReactComponent };